export const tellUsAboutYourselfBillboardTemplate = /* html */ `
  <style>
    .tour-tell-us .header-text {
      font-size: 2rem;
    }

    .tour-tell-us .text-body-secondary {
      color: var(--bs-gray-800) !important;
    }

    .tour-tell-us .tour-image {
      width: 100%;
    }

    .tour-tell-us .btn.btn-outline-secondary {
      color: var(--bs-dark);
      border-color: var(--bs-dark);
    }

    [data-bs-theme='dark'] .tour-tell-us h5 {
      color: var(--bs-emphasis-color);
    }

    [data-bs-theme='dark'] .tour-tell-us .text-body-secondary {
      color: var(--bs-emphasis-color) !important;
    }

    [data-bs-theme='dark'] .tour-tell-us .chip {
      border-color: var(--bs-gray-300);
      color: var(--bs-gray-300);
    }

    [data-bs-theme='dark'] .tour-tell-us .btn.btn-outline-secondary {
      border-color: var(--bs-gray-300);
      color: var(--bs-gray-300);
    }
  </style>

  <div class="tour-tell-us d-flex align-items-center justify-content-center py-5 px-4">
    <div class="row">
      <div class="col-6">
        <header>
        <h1 class="display-3 header-text">{{title}}</h1>
        </header>

        <div class="d-flex flex-column justify-content-center h-75">
          <div class="py-3">
            <label for="setup-choice" class="form-label">
              <h5>{{setupQuestion}}<span class="fw-normal">*</span></h5>
            </label>
            <div id="setup-choice" class="d-flex flex-wrap gap-2">
              <button
                type="button"
                class="chip chip-outline chip-input py-4 rounded-pill"
                data-tour-action-key="selectYesButton"
              ></button>
              <button
                type="button"
                class="chip chip-outline chip-input py-4 rounded-pill"
                data-tour-action-key="selectNoButton"
              ></button>
            </div>
          </div>
          <p class="small text-body-secondary">
            {{disclaimer}}
          </p>
        </div>
      </div>

      <div class="col-6">
        <img
          src="/assets/img/tell-us.png"
          style="aspect-ratio: 461 / 500;"
          class="img-fluid tour-image"
          alt="Illustration of fleet management with a globe, computer, and vehicles."
        />
     </div>
    </div>
    <footer class="position-absolute bottom-0 end-0 p-4 gap-2 d-flex">
      <button
        type="button"
        class="btn btn-outline-secondary btn-lg"
        data-tour-action-key="skipButton"
      ></button>
      <button
        type="button"
        class="btn btn-primary btn-lg"
        disabled data-tour-action-key="nextButton"
      ></button>
    </footer>
  </div>
`;
